import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppUiModule } from '../../ui/app-ui.module';
import { SortableColumnComponent } from './sortable-column.component';
import { SortService } from './sortable-column.service';
import { SortableTableDirective } from './sortable-column.directive';

@NgModule({
  declarations: [SortableColumnComponent, SortableTableDirective],
  imports: [CommonModule, AppUiModule],
  exports: [SortableColumnComponent, SortableTableDirective],
  providers: [SortService],
})
export class TableSortingModule {}
